import WeatherApp from './components/WeatherApp';

export default function App() {
  return (
    <WeatherApp />
  );
}